import { assign } from 'lodash';
import { OriginDestinationOption } from "./OTAAirScheduleResponse";

export class ChooseFlightData {
    _outbound: OriginDestinationOption;
    _inbound: OriginDestinationOption;

    get outbound() {
        return assign(new OriginDestinationOption(), this._outbound);
    }

    get inbound() {
        return assign(new OriginDestinationOption(), this._inbound);
    }

    set outbound(outbound: OriginDestinationOption) {
        this._outbound = outbound;
    }

    set inbound(inbound: OriginDestinationOption) {
        this._inbound = inbound;
    }
}